export default __webpack_public_path__ + "static/media/audioplayer.e1e67a65.png";